export default "__VITE_ASSET__bb64ccd4__"